// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ModbusInterpretation } from "./modbus-interpretation";
import { ModbusWordOrder } from "./modbus-word-order";
import { ModbusWriteType } from "./modbus-write-type";
import { ValuedMessage, ValuedMessageT, verifyValuedMessage } from "../ln2/valued-message";
import { BoolValue, BoolValueT, verifyBoolValue } from "../value/bool-value";
import { ByteValue, ByteValueT, verifyByteValue } from "../value/byte-value";
import { DoubleValue, DoubleValueT, verifyDoubleValue } from "../value/double-value";
import { FloatValue, FloatValueT, verifyFloatValue } from "../value/float-value";
import { IntValue, IntValueT, verifyIntValue } from "../value/int-value";
import { LongValue, LongValueT, verifyLongValue } from "../value/long-value";
import { ShortValue, ShortValueT, verifyShortValue } from "../value/short-value";
import { StringValue, StringValueT, verifyStringValue } from "../value/string-value";
import { UByteValue, UByteValueT, verifyUByteValue } from "../value/ubyte-value";
import { UIntValue, UIntValueT, verifyUIntValue } from "../value/uint-value";
import { ULongValue, ULongValueT, verifyULongValue } from "../value/ulong-value";
import { UShortValue, UShortValueT, verifyUShortValue } from "../value/ushort-value";
import { Value, unionToValue, unionListToValue } from "../value/value";

/**
 * Config-time write mapping: LN2 message → device register.
 */
export class ModbusWriteEntry implements flatbuffers.IUnpackableObject<ModbusWriteEntryT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ModbusWriteEntry {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsModbusWriteEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: ModbusWriteEntry,
  ): ModbusWriteEntry {
    return (obj || new ModbusWriteEntry()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsModbusWriteEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: ModbusWriteEntry,
  ): ModbusWriteEntry {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ModbusWriteEntry()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * Base register address (before lift offset is added).
   */
  registerAddress(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  /**
   * Type of Modbus write request.
   */
  writeType(): ModbusWriteType {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ModbusWriteType.WriteSingleRegister;
  }

  /**
   * How to interpret the register value.
   */
  interpretation(): ModbusInterpretation {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ModbusInterpretation.WholeValue;
  }

  /**
   * For `BitmaskSingleBit`: which bit within the register.
   */
  bit(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  /**
   * For `BitmaskSingleBit`: bits per register (8 or 16).
   */
  bitsPerRegister(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 16;
  }

  /**
   * For `MaskWriteRegister`: AND mask.
   */
  andMask(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 65535;
  }

  /**
   * For `MaskWriteRegister`: OR mask.
   */
  orMask(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  /**
   * The LN2 message that triggers this write. Same as read entry —
   * `ValuedMessage` at config time, wrapped in `FrontEndMessage` at expansion.
   */
  ln2Message(obj?: ValuedMessage): ValuedMessage | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? (obj || new ValuedMessage()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Duplicate this entry per floor at expansion time.
   */
  floorsBased(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Duplicate this entry per lift using bank `offset_mapping`.
   */
  unitsBased(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Human-readable label for the editor UI.
   */
  label(): string | null;
  label(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  label(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Fixed value to write to the Modbus register when the LN2 message fires.
   * Only used when `interpretation` = `WholeValue` and `floors_based` = false.
   * For `BitmaskSingleBit`, use the `bit` field instead.
   * For `MaskWriteRegister`, use `and_mask` / `or_mask` instead.
   * Field appended last (slot 11) for binary backward compatibility.
   */
  writeValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  dataTypeType(): Value {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Value.NONE;
  }

  /**
   * Data type for multi-register interpretation. Uses Value.Value union
   * discriminant — same mapping as ModbusReadEntry.data_type above.
   * NONE → uint16 (default/backwards compatible).
   */
  dataType<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  /**
   * Word order for combining multi-register values.
   */
  wordOrder(): ModbusWordOrder {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ModbusWordOrder.BigEndianWordFirst;
  }

  static startModbusWriteEntry(builder: flatbuffers.Builder) {
    builder.startObject(15);
  }

  static addRegisterAddress(builder: flatbuffers.Builder, registerAddress: number) {
    builder.addFieldInt16(0, registerAddress, 0);
  }

  static addWriteType(builder: flatbuffers.Builder, writeType: ModbusWriteType) {
    builder.addFieldInt8(1, writeType, ModbusWriteType.WriteSingleRegister);
  }

  static addInterpretation(builder: flatbuffers.Builder, interpretation: ModbusInterpretation) {
    builder.addFieldInt8(2, interpretation, ModbusInterpretation.WholeValue);
  }

  static addBit(builder: flatbuffers.Builder, bit: number) {
    builder.addFieldInt8(3, bit, 0);
  }

  static addBitsPerRegister(builder: flatbuffers.Builder, bitsPerRegister: number) {
    builder.addFieldInt8(4, bitsPerRegister, 16);
  }

  static addAndMask(builder: flatbuffers.Builder, andMask: number) {
    builder.addFieldInt16(5, andMask, 65535);
  }

  static addOrMask(builder: flatbuffers.Builder, orMask: number) {
    builder.addFieldInt16(6, orMask, 0);
  }

  static addLn2Message(builder: flatbuffers.Builder, ln2MessageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, ln2MessageOffset, 0);
  }

  static addFloorsBased(builder: flatbuffers.Builder, floorsBased: boolean) {
    builder.addFieldInt8(8, +floorsBased, +false);
  }

  static addUnitsBased(builder: flatbuffers.Builder, unitsBased: boolean) {
    builder.addFieldInt8(9, +unitsBased, +false);
  }

  static addLabel(builder: flatbuffers.Builder, labelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, labelOffset, 0);
  }

  static addWriteValue(builder: flatbuffers.Builder, writeValue: number) {
    builder.addFieldInt16(11, writeValue, 0);
  }

  static addDataTypeType(builder: flatbuffers.Builder, dataTypeType: Value) {
    builder.addFieldInt8(12, dataTypeType, Value.NONE);
  }

  static addDataType(builder: flatbuffers.Builder, dataTypeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, dataTypeOffset, 0);
  }

  static addWordOrder(builder: flatbuffers.Builder, wordOrder: ModbusWordOrder) {
    builder.addFieldInt8(14, wordOrder, ModbusWordOrder.BigEndianWordFirst);
  }

  static endModbusWriteEntry(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): ModbusWriteEntryT {
    return new ModbusWriteEntryT(
      this.registerAddress(),
      this.writeType(),
      this.interpretation(),
      this.bit(),
      this.bitsPerRegister(),
      this.andMask(),
      this.orMask(),
      this.ln2Message() !== null ? this.ln2Message()!.unpack() : null,
      this.floorsBased(),
      this.unitsBased(),
      this.label(),
      this.writeValue(),
      this.dataTypeType(),
      (() => {
        const temp = unionToValue(this.dataTypeType(), this.dataType.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.wordOrder(),
    );
  }

  unpackTo(_o: ModbusWriteEntryT): void {
    _o.registerAddress = this.registerAddress();
    _o.writeType = this.writeType();
    _o.interpretation = this.interpretation();
    _o.bit = this.bit();
    _o.bitsPerRegister = this.bitsPerRegister();
    _o.andMask = this.andMask();
    _o.orMask = this.orMask();
    _o.ln2Message = this.ln2Message() !== null ? this.ln2Message()!.unpack() : null;
    _o.floorsBased = this.floorsBased();
    _o.unitsBased = this.unitsBased();
    _o.label = this.label();
    _o.writeValue = this.writeValue();
    _o.dataTypeType = this.dataTypeType();
    _o.dataType = (() => {
      const temp = unionToValue(this.dataTypeType(), this.dataType.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.wordOrder = this.wordOrder();
  }

  unpackFields(...fields: string[]): ModbusWriteEntryT {
    const t = new ModbusWriteEntryT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("register_address")) {
      t.registerAddress = this.registerAddress();
    }
    if (fieldSet.has("write_type")) {
      t.writeType = this.writeType();
    }
    if (fieldSet.has("interpretation")) {
      t.interpretation = this.interpretation();
    }
    if (fieldSet.has("bit")) {
      t.bit = this.bit();
    }
    if (fieldSet.has("bits_per_register")) {
      t.bitsPerRegister = this.bitsPerRegister();
    }
    if (fieldSet.has("and_mask")) {
      t.andMask = this.andMask();
    }
    if (fieldSet.has("or_mask")) {
      t.orMask = this.orMask();
    }
    if (fieldSet.has("ln2_message")) {
      t.ln2Message = this.ln2Message() !== null ? this.ln2Message()!.unpack() : null;
    }
    if (fieldSet.has("floors_based")) {
      t.floorsBased = this.floorsBased();
    }
    if (fieldSet.has("units_based")) {
      t.unitsBased = this.unitsBased();
    }
    if (fieldSet.has("label")) {
      t.label = this.label();
    }
    if (fieldSet.has("write_value")) {
      t.writeValue = this.writeValue();
    }
    if (fieldSet.has("data_type_type")) {
      t.dataTypeType = this.dataTypeType();
    }
    if (fieldSet.has("data_type")) {
      t.dataType = (() => {
        const temp = unionToValue(this.dataTypeType(), this.dataType.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("word_order")) {
      t.wordOrder = this.wordOrder();
    }
    return t;
  }
}

export class ModbusWriteEntryT implements flatbuffers.IGeneratedObject {
  constructor(
    public registerAddress: number = 0,
    public writeType: ModbusWriteType = ModbusWriteType.WriteSingleRegister,
    public interpretation: ModbusInterpretation = ModbusInterpretation.WholeValue,
    public bit: number = 0,
    public bitsPerRegister: number = 16,
    public andMask: number = 65535,
    public orMask: number = 0,
    public ln2Message: ValuedMessageT | null = null,
    public floorsBased: boolean = false,
    public unitsBased: boolean = false,
    public label: string | Uint8Array | null = null,
    public writeValue: number = 0,
    public dataTypeType: Value = Value.NONE,
    public dataType:
      | BoolValueT
      | ByteValueT
      | DoubleValueT
      | FloatValueT
      | IntValueT
      | LongValueT
      | ShortValueT
      | StringValueT
      | UByteValueT
      | UIntValueT
      | ULongValueT
      | UShortValueT
      | null = null,
    public wordOrder: ModbusWordOrder = ModbusWordOrder.BigEndianWordFirst,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const ln2Message = this.ln2Message !== null ? this.ln2Message!.pack(builder) : 0;
    const label = this.label !== null ? builder.createString(this.label!) : 0;
    const dataType = builder.createObjectOffset(this.dataType);

    ModbusWriteEntry.startModbusWriteEntry(builder);
    ModbusWriteEntry.addRegisterAddress(builder, this.registerAddress);
    ModbusWriteEntry.addWriteType(builder, this.writeType);
    ModbusWriteEntry.addInterpretation(builder, this.interpretation);
    ModbusWriteEntry.addBit(builder, this.bit);
    ModbusWriteEntry.addBitsPerRegister(builder, this.bitsPerRegister);
    ModbusWriteEntry.addAndMask(builder, this.andMask);
    ModbusWriteEntry.addOrMask(builder, this.orMask);
    ModbusWriteEntry.addLn2Message(builder, ln2Message);
    ModbusWriteEntry.addFloorsBased(builder, this.floorsBased);
    ModbusWriteEntry.addUnitsBased(builder, this.unitsBased);
    ModbusWriteEntry.addLabel(builder, label);
    ModbusWriteEntry.addWriteValue(builder, this.writeValue);
    ModbusWriteEntry.addDataTypeType(builder, this.dataTypeType);
    ModbusWriteEntry.addDataType(builder, dataType);
    ModbusWriteEntry.addWordOrder(builder, this.wordOrder);

    return ModbusWriteEntry.endModbusWriteEntry(builder);
  }

  clone(): ModbusWriteEntryT {
    const obj = new ModbusWriteEntryT();
    obj.registerAddress = this.registerAddress;
    obj.writeType = this.writeType;
    obj.interpretation = this.interpretation;
    obj.bit = this.bit;
    obj.bitsPerRegister = this.bitsPerRegister;
    obj.andMask = this.andMask;
    obj.orMask = this.orMask;
    obj.ln2Message = this.ln2Message !== null ? this.ln2Message!.clone() : null;
    obj.floorsBased = this.floorsBased;
    obj.unitsBased = this.unitsBased;
    obj.label = this.label;
    obj.writeValue = this.writeValue;
    obj.dataTypeType = this.dataTypeType;
    obj.dataType =
      this.dataType !== null && typeof (this.dataType as any).clone === "function"
        ? (this.dataType as any).clone()
        : this.dataType;
    obj.wordOrder = this.wordOrder;
    return obj;
  }

  equals(other: ModbusWriteEntryT): boolean {
    if (this.registerAddress !== other.registerAddress) return false;
    if (this.writeType !== other.writeType) return false;
    if (this.interpretation !== other.interpretation) return false;
    if (this.bit !== other.bit) return false;
    if (this.bitsPerRegister !== other.bitsPerRegister) return false;
    if (this.andMask !== other.andMask) return false;
    if (this.orMask !== other.orMask) return false;
    if (this.ln2Message !== null && other.ln2Message !== null) {
      if (!this.ln2Message!.equals(other.ln2Message!)) return false;
    } else if (this.ln2Message !== other.ln2Message) return false;
    if (this.floorsBased !== other.floorsBased) return false;
    if (this.unitsBased !== other.unitsBased) return false;
    if (this.label !== other.label) return false;
    if (this.writeValue !== other.writeValue) return false;
    if (this.dataTypeType !== other.dataTypeType) return false;
    if (this.dataType !== null && other.dataType !== null) {
      if (typeof (this.dataType as any).equals === "function") {
        if (!(this.dataType as any).equals(other.dataType)) return false;
      } else if (this.dataType !== other.dataType) return false;
    } else if (this.dataType !== other.dataType) return false;
    if (this.wordOrder !== other.wordOrder) return false;
    return true;
  }
}

export function verifyModbusWriteEntry(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 2);
    verifier.checkScalarField(tablePos, 16, 2);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 18);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyValuedMessage(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 20, 1);
    verifier.checkScalarField(tablePos, 22, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 26, 2);
    verifier.checkScalarField(tablePos, 28, 1);
    verifier.checkUnionConsistency(tablePos, 28, 30, "data_type");
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 28);
        switch (uType) {
          case 1: // BoolValue
            {
              const o = verifier.readInt32(pos);
              verifyBoolValue(verifier, pos + o);
            }
            break;
          case 2: // ByteValue
            {
              const o = verifier.readInt32(pos);
              verifyByteValue(verifier, pos + o);
            }
            break;
          case 3: // UByteValue
            {
              const o = verifier.readInt32(pos);
              verifyUByteValue(verifier, pos + o);
            }
            break;
          case 4: // ShortValue
            {
              const o = verifier.readInt32(pos);
              verifyShortValue(verifier, pos + o);
            }
            break;
          case 5: // UShortValue
            {
              const o = verifier.readInt32(pos);
              verifyUShortValue(verifier, pos + o);
            }
            break;
          case 6: // IntValue
            {
              const o = verifier.readInt32(pos);
              verifyIntValue(verifier, pos + o);
            }
            break;
          case 7: // UIntValue
            {
              const o = verifier.readInt32(pos);
              verifyUIntValue(verifier, pos + o);
            }
            break;
          case 8: // LongValue
            {
              const o = verifier.readInt32(pos);
              verifyLongValue(verifier, pos + o);
            }
            break;
          case 9: // ULongValue
            {
              const o = verifier.readInt32(pos);
              verifyULongValue(verifier, pos + o);
            }
            break;
          case 10: // FloatValue
            {
              const o = verifier.readInt32(pos);
              verifyFloatValue(verifier, pos + o);
            }
            break;
          case 11: // DoubleValue
            {
              const o = verifier.readInt32(pos);
              verifyDoubleValue(verifier, pos + o);
            }
            break;
          case 12: // StringValue
            {
              const o = verifier.readInt32(pos);
              verifyStringValue(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkScalarField(tablePos, 32, 1);
  } finally {
    verifier.popDepth();
  }
}
